var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-modal", { attrs: { id: "bibModal", "hide-footer": true } }, [
    _c(
      "div",
      { attrs: { id: "bibForm" } },
      [
        _c(
          "div",
          { staticClass: "formTitle" },
          [
            _c("svg-image", { attrs: { image: "iconBib" } }),
            _vm._v(" "),
            _c("h5", [_vm._v(_vm._s(_vm.$t("bib.modal.head")))]),
            _vm._v(" "),
            _c("h6", [_vm._v(_vm._s(_vm.$t("bib.modal.date")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c("b-row", {
          domProps: { innerHTML: _vm._s(_vm.$t("bib.modal.step")) },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "groupLabel" }, [
          _c("label", [_vm._v(_vm._s(_vm.$t("bib.modal.ltnc")))]),
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "termsConditions",
          domProps: { innerHTML: _vm._s(_vm.$t("bib.modal.tnc")) },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "groupLabel" }, [
          _c("label", [_vm._v(_vm._s(_vm.$t("bib.modal.lform")))]),
        ]),
        _vm._v(" "),
        _c(
          "b-form",
          [
            _c(
              "b-form-group",
              {
                attrs: {
                  id: "",
                  label: _vm.$t("bib.modal.fname"),
                  "label-for": "",
                  description: _vm.$t("bib.modal.fnamedesc"),
                },
              },
              [
                _c("b-form-input", {
                  attrs: { id: "name", required: "", placeholder: "" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                attrs: {
                  id: "",
                  label: _vm.$t("bib.modal.femail"),
                  "label-for": "",
                  description: _vm.$t("bib.modal.femaildesc"),
                },
              },
              [
                _c("b-form-input", {
                  attrs: { id: "email", type: "email", required: "" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-checkbox",
              {
                attrs: {
                  id: "acceptance",
                  name: "acceptance",
                  value: "accepted",
                  "unchecked-value": "not_accepted",
                },
              },
              [
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("bib.modal.facceptance")),
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "clearfix" },
              [
                _c(
                  "b-button",
                  {
                    attrs: {
                      block: "",
                      type: "submit",
                      variant: "primary",
                      size: "lg",
                    },
                  },
                  [
                    _c("b-spinner", { attrs: { small: "", type: "grow" } }),
                    _vm._v(" " + _vm._s(_vm.$t("bib.modal.btn"))),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/components/BibModal.vue